import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grommet, TextInput, Image, Text } from "grommet";
import { debounce } from "lodash";
import React, { useCallback, useRef, useState } from "react";
import Avatar from "react-avatar";
import { useUser } from "../account/AccountStore";

import { EventViewModel, getEvents } from "./EventsStore";

const formatSuggestions = (suggestions) =>
    suggestions.map(({ id, name, logoUri }, index, list) => ({
        label: (
            <Box direction="row" align="center" gap="small" border={index < list.length - 1 ? "bottom" : undefined} pad="small">
                <Avatar name={name} size="30px" round src={logoUri}></Avatar>
                <Text>
                    <strong>{name}</strong>
                </Text>
            </Box>
        ),
        value: { id, name, logoUri },
    }));

const EventSearch = ({ onSelect, ...props }) => {
    const user = useUser();

    const [value, setValue] = useState("");
    const [events, setEvents] = useState([] as EventViewModel[]);
    const [suggestions, setSuggestions] = useState([]);
    const textRef = useRef<HTMLInputElement>(null);

    const [selectedEvent, setSelectedEvent] = useState({} as EventViewModel);

    React.useEffect(() => {
        getEvents("").then((result) => {
            setEvents(result);
            if (result.length == 1) {
                selectEvent(result[0].id);
            }
            setupSuggestions(result, "");
        });
    }, []);

    const setupSuggestions = (events, filter) => {
        setSuggestions(
            formatSuggestions(
                events.filter((o) => {
                    let r = new RegExp(filter, "i");
                    return r.test(o.name);
                })
            )
        );
    };

    const onChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        setupSuggestions(events, newValue);
    };

    const onSuggestionSelect = (event) => {
        const entity = event.suggestion.value;
        selectEvent(entity.id);
        setValue("");
        //@ts-ignore
        textRef.current.blur();
    };

    const selectEvent = (eventId?) => {
        if (!eventId) {
            onSelect({} as EventViewModel);
            setSelectedEvent({} as EventViewModel);
        } else {
            let event = events.find((e) => e.id == eventId);
            if (event) {
                onSelect(event);
                setSelectedEvent(event);
            }
        }
    };

    return (
        <Box direction="row-responsive" align="center">
            {!selectedEvent.id && <TextInput ref={textRef} placeholder={props.placeholder || "Search Event ..."} icon={<FontAwesomeIcon icon={["fad", "magnifying-glass"]} />} suggestions={suggestions} value={value} onChange={onChange} onSuggestionSelect={onSuggestionSelect} />}
            {selectedEvent.id && (
                <Box direction="row" align="center" gap="small" pad="small">
                    <Avatar name={selectedEvent.name} size="30px" round></Avatar>
                    <Text>
                        <strong>{selectedEvent.name}</strong>
                    </Text>
                    <Box onClick={() => selectEvent()}>
                        <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default EventSearch;
